export default {
      id: "research-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#research",
      toString: function () {
        return this.url;
      }
    }